import React, { useState, useEffect } from 'react';
import './ContactSupport.css'; 
import human from '../assets/healthicons_call-centre.jpg';
import whatsap from '../assets/ic_round-whatsapp.png';
import call from '../assets/ion_call-outline.svg';
import call2 from '../assets/Vector (5).png';
import mail from '../assets/ic_outline-email.svg'
import tick from '../assets/Vector 153.png';

import BASE_URL from '../config';

const CALLBACK_KEY = 'vigovia_callback_time';

const ContactSupport = () => {
  const [activeTab, setActiveTab] = useState('contactform');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });

  // Callback button state
  const [callbackState, setCallbackState] = useState({
    requested: false,
    phoneEnabled: false,
    phoneHover: false,
    timeSince: 0
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Log the JSON data being sent
    console.log('Form data being submitted:', JSON.stringify(formData));

    try {
     const response = await fetch(`${BASE_URL}/api/user_support?status=PENDING`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });


      // Check if the request was successful
      if (response.ok) {
        console.log('Form submitted successfully');
        // You can also show a success message to the user here
      } else {
        console.error('Failed to submit the form');
        // Handle error case here
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // Handle callback request
  const handleCallbackRequest = () => {
    const now = Date.now();
    localStorage.setItem(CALLBACK_KEY, now);
    setCallbackState({
      requested: true,
      phoneEnabled: false,
      phoneHover: false,
      timeSince: 0
    });
  };

  // Handle phone button click (second callback)
  const handlePhoneCallback = () => {
    const now = Date.now();
    localStorage.setItem(CALLBACK_KEY, now);
    setCallbackState({
      requested: true,
      phoneEnabled: false,
      phoneHover: false,
      timeSince: 0
    });
  };

  // Timer logic for callback state
  useEffect(() => {
    const checkCallbackState = () => {
      const stored = localStorage.getItem(CALLBACK_KEY);
      if (!stored) {
        setCallbackState({
          requested: false,
          phoneEnabled: false,
          phoneHover: false,
          timeSince: 0
        });
        return;
      }
      const diff = Date.now() - Number(stored);
      // 2 hours = 7200000 ms, 12 hours = 43200000 ms
      if (diff >= 43200000) {
        // Reset after 12 hours
        localStorage.removeItem(CALLBACK_KEY);
        setCallbackState({
          requested: false,
          phoneEnabled: false,
          phoneHover: false,
          timeSince: 0
        });
      } else if (diff >= 7200000) {
        // After 2 hours, phone enabled
        setCallbackState({
          requested: true,
          phoneEnabled: true,
          phoneHover: false,
          timeSince: diff
        });
      } else {
        // In between
        setCallbackState({
          requested: true,
          phoneEnabled: false,
          phoneHover: false,
          timeSince: diff
        });
      }
    };

    checkCallbackState();
    const interval = setInterval(checkCallbackState, 1000 * 60); // check every minute
    return () => clearInterval(interval);
  }, []);

  // UI for callback section
  const renderCallbackSection = () => {
    if (!callbackState.requested) {
      // Initial state
      return (
        <button
          style={{ borderRadius: '30px', backgroundColor: '#541C9C', color: 'white', display: 'flex', alignItems: 'center', gap: 8, padding: '4px 10px', fontWeight: 600, fontSize: '1rem', border: 'none' }}
          onClick={handleCallbackRequest}
        >
          <img src={call} style={{ width: '30px',height:'30px', borderRadius: '30px' }} alt="Call" />
          Request call back
        </button>
      );
    }
    // After request
    return (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 12 }}>
        <button
          style={{
            borderRadius: '30px',
            background: '#0E961B',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 20px',
            fontWeight: 600,
            fontSize: '1rem',
            border: 'none',
            cursor: 'not-allowed'
          }}
          disabled
        >
          <img src={tick} style={{ width: '30px', borderRadius: '30px' }} alt="Tick" />
          We'll reach out soon
        </button>
        <div
          style={{
            border: 'solid 1px #321e5d',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: callbackState.phoneEnabled ? '#e6f9e8' : '#f3f3f3',
            cursor: callbackState.phoneEnabled ? 'pointer' : 'not-allowed',
            position: 'relative'
          }}
          onClick={callbackState.phoneEnabled ? handlePhoneCallback : undefined}
          onMouseEnter={() => setCallbackState(s => ({ ...s, phoneHover: true }))}
          onMouseLeave={() => setCallbackState(s => ({ ...s, phoneHover: false }))}
        >
          <img
            style={{
              width: '20px',
              height: '20px',
              filter: callbackState.phoneEnabled ? 'none' : 'grayscale(1) brightness(0.7)'
            }}
            src={call2}
            alt="Call Again"
          />
          {/* Tooltip */}
          {!callbackState.phoneEnabled && callbackState.phoneHover && (
            <div style={{
              position: 'absolute',
              bottom: '-40px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: '#321e5d',
              color: 'white',
              padding: '6px 12px',
              borderRadius: '8px',
              fontSize: '0.9rem',
              whiteSpace: 'nowrap',
              zIndex: 10
            }}>
              You can place another callback request after 2 hours
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <div style={{ fontWeight: '500', fontSize: '250%' }}>Contact Support</div>
      <div className="contact-support-container">
        <div className="tabs">
          <button
            className={`tab${activeTab === 'contactform' ? '-active' : ''}`}
            onClick={() => setActiveTab('contactform')}
          >
            Contact Form
          </button>
          <button
            className={`tab${activeTab === 'contactinfo' ? '-active' : ''}`}
            onClick={() => setActiveTab('contactinfo')}
          >
            Contact Info
          </button>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === 'contactform' && (
            <div className="contact-form">
              <form onSubmit={handleSubmit}>
                <div className="d-flex flex-column flex-sm-row justify-content-between gap-3">
                  <div  className="contact-form-group">
                    <label>Email</label>
                    <input 
                      type="email" 
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="contact-form-group">
                    <label>Mobile no.</label>
                    <input 
                      type="text" 
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="contact-form-group">
                  <label>Message / Query</label>
                  <textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                </div>
                <button type="submit" className="query-submit-button">
                  Submit
                </button>
              </form>
            </div>
          )}

          {activeTab === 'contactinfo' && (
            <div className="contact-info">
              <p style={{ fontSize: '110%' }}>
                Get in touch with us for any inquiries, assistance, or feedback. We’re here to help make your travel experience seamless and memorable.
              </p>
              <br />
              <div className="contact-details">
                {renderCallbackSection()}
                <br />
                <br />
                <p>
                  <i className="fa fa-phone"></i>
                  <img src={whatsap} style={{ width: '30px' }} alt="WhatsApp" /> +91 - 9274648789 (8:00am to 7:00 pm)
                </p>
                <br />
                <p>
                  <i className="fa fa-envelope"></i>
                  <img src={mail} style={{ width: '30px' }} alt="Mail" /> contact@vigovia.com
                </p>
                <br />
                <p>
                  <i className="fa fa-whatsapp"></i>
                  <img src={human} style={{ width: '30px' }} alt="Human" /> +91 - 9274648789 (8:00am to 7:00 pm)
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;
